import { ObjetKForm, requiredRule, combineRules } from '@siclop/kstone-vue'

export class ActivityTypeForm extends ObjetKForm {
  code: string = ''
  label: string = ''
  order: number = 0
  color: string = '#3498db'
  coefficient: number = 1.0
  description: string = ''
  estimationScaleId?: number

  static validationRules = {
    code: combineRules(requiredRule('Le code est obligatoire')),
    label: combineRules(requiredRule('Le libellé est obligatoire'))
  }

  constructor(data?: Partial<ActivityTypeForm>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.label = data.label ?? ''
      this.order = data.order ?? 0
      this.color = data.color ?? '#3498db'
      this.coefficient = data.coefficient ?? 1.0
      this.description = data.description ?? ''
      this.estimationScaleId = data.estimationScaleId
    }
  }
}
